import type { IOrganizationIntegrationIdSmart } from './OrganizationIntegrationIdSmart.interface';

export default class OrganizationIntegrationIdSmart implements IOrganizationIntegrationIdSmart {
  emailCustomContent: string;
  enabled: boolean;

  isEnabled() {
    return this.enabled;
  }

  static build = (data: IOrganizationIntegrationIdSmart) =>
    new OrganizationIntegrationIdSmart(data);

  static blank = () => new OrganizationIntegrationIdSmart();

  /**
   * Constructor
   * @param {IOrganizationIntegrationIdSmart} data
   */
  constructor(data?: IOrganizationIntegrationIdSmart) {
    this.emailCustomContent = data?.emailCustomContent || undefined;
    this.enabled = data?.enabled === true;
  }
}
